import script from "./TotalScore.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalScore.vue?vue&type=script&setup=true&lang=js"

import "./TotalScore.vue?vue&type=style&index=0&id=5405278f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5405278f"]])

export default __exports__